import * as agentTypes from './ActionTypes';
import * as types from '../actions/PlanOrderActionTypes';
import AnnotationApi from '../../../../planannotation/PlanAnnotationsApi';
import { IUploadPlanOrderStoreyAnnotationFileResult } from './Entities';
import Api from './Api';

function uploadStoreyAnnotationFileSucceeded(result: any): any {
    return {
        type: agentTypes.UPLOAD_STOREY_ANNOTATION_FILE_SUCCESS,
        result: result
    };
}

export function addPlanOrderStoreyAnnotationFile(
    response: IUploadPlanOrderStoreyAnnotationFileResult
) {
    return (dispatch: (response: any) => void, getState: (error: any) => void) =>
        dispatch(uploadStoreyAnnotationFileSucceeded(response));
}

function uploadAnnotationFileSucceeded(result: any): any {
    return { type: agentTypes.UPLOAD_ANNOTATION_FILE_SUCCESS, result: result };
}

export function addPlanOrderAnnotationFile(response: any) {
    return (dispatch: (response: any) => void, getState: (error: any) => void) =>
        dispatch(uploadAnnotationFileSucceeded(response));
}

function returnPlanOrderSucceeded(result: any): any {
    return { type: agentTypes.AGENT_RETURN_PLAN_ORDER_SUCCESS, result: result };
}

function saveAnnotationSucceeded(result: any): any {
    return { type: types.SAVE_PLAN_ANNOTATION_SUCCESS, result: result };
}

export function saveAnnotation(
    planOrderStoreyFileId: number,
    data: string,
    hasDoneCrop: boolean,
    revisionType: number,
    annotationType: string,
    hasDoneFlip: boolean
): any {
    return (dispatch: any, getState: any) =>
        AnnotationApi.saveAnnotation(
            planOrderStoreyFileId,
            data,
            hasDoneCrop,
            revisionType,
            annotationType,
            hasDoneFlip
        ).then((result: any) => {
            dispatch(saveAnnotationSucceeded(result));
            return result;
        });
}

export function returnPlanOrder(planOrderId: number, customerReturnedMessage: string) {
    return (dispatch: any) =>
        Api.returnPlanOrder(planOrderId, customerReturnedMessage).then((result: any) => {
            dispatch(returnPlanOrderSucceeded({ status: result }));
        });
}
